module.exports = __webpack_public_path__ + "img/ZYSXRS.cc954649.png";